import { render, staticRenderFns } from "./ShippingLocaleSwitcher.vue?vue&type=template&id=edbc2132&scoped=true&"
import script from "./ShippingLocaleSwitcher.vue?vue&type=script&lang=js&"
export * from "./ShippingLocaleSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLocaleSwitcher.vue?vue&type=style&index=0&id=edbc2132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbc2132",
  null
  
)

export default component.exports